import * as React from "react";
import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { IButtonProps } from "../IButtonProps";
import { Strings } from "../../Stores/StringsStore";

interface ISearchDocumentButtonProps extends IButtonProps {
	on: boolean;
}

@observer
export class SearchDocumentButton extends React.Component<ISearchDocumentButtonProps> {


	@computed get tooltip() {
		return this.props.on ? Strings.reader.searchBarHideButtonTooltip : Strings.reader.searchBarShowButtonTooltip;
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : this.tooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M32,29.17L20.06,17.23a11,11,0,1,0-2.83,2.83L29.17,32ZM3,11a8,8,0,1,1,8,8A8,8,0,0,1,3,11Z" />
				</svg>
			</i>
		</Button>;
	}
}
